// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tsmpYX58xNcvgIDKpJGg{width:100%;height:100%;padding:8px 80px 36px}.tsmpYX58xNcvgIDKpJGg .lyBd2pWdHBY2K4_OQ119{justify-content:flex-end;gap:8px;padding:64px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tsmpYX58xNcvgIDKpJGg`,
	"actions": `lyBd2pWdHBY2K4_OQ119`
};
export default ___CSS_LOADER_EXPORT___;
